export const bsBlocked = false
export const discountCodeMaxLength = 8
